import { docViewerKind } from './doc-viewer';

/** The bit of a chat attachment this decision needs. Structural rather than the entity type, so this
 *  module imports nothing from common-lib and stays testable without the app's dependency graph. */
export interface InlineCandidate {
  fileName?: string;
  mimeType?: string;
}

/**
 * Whether a chat attachment shows its CONTENT in the conversation rather than a chip that opens a window
 * over it.
 *
 * Reading the file is the point of sending it, and the popup interrupted the thread to allow it — the
 * complaint behind this. So the default inverts: anything the classifier can render, renders here.
 *
 * Three things deliberately do NOT:
 *   - a kind of `null` — a workbook, a `.zip`, anything unclaimed. There is no body to show, and the chip
 *     is the honest hand-off to Download / Open in new tab.
 *   - an image — already its own preview, and its tighter single-image layout reads better than a framed
 *     document body.
 *   - anything still resolving — a `vfsPath` artifact has no content until the workspace file lands, and
 *     classifying on an empty body answers for the wrong file.
 *
 * Audio never reaches this: chat routes an `audio/*` attachment to the player before the classifier runs.
 */
export function rendersInline(att: InlineCandidate, content: string, pending: boolean): boolean {
  if (pending) return false;
  if (att.mimeType?.startsWith('image/')) return false;
  return docViewerKind(att.fileName, content || undefined, att.mimeType) !== null;
}
